import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useScheduleFilterStore = defineStore(
  'schedule-filters',
  () => {
    const search = ref<string>('')
    const isMigratedFromVuex = ref<boolean>(false)
    const lastViewedSchedule = ref<string>('day')
    const showOfflineUnits = ref<boolean>()
    const showStandbyUnits = ref<boolean>()
    const showUnitsWithNoAssignedJobs = ref<boolean>()
    const resetFilters = ref<boolean>(false)
    const divisionFiltersExplicitlySet = ref<boolean>(false)
    const resourceTypeFiltersExplicitlySet = ref<boolean>(false)
    const serviceProviderFiltersExplicitlySet = ref<boolean>(false)

    const updateShowOfflineUnits = (show: boolean) => {
      showOfflineUnits.value = show
    }

    const updateShowStandbyUnits = (show: boolean) => {
      showStandbyUnits.value = show
    }

    const updateShowUnitsWithNoAssignedJobs = (show: boolean) => {
      showUnitsWithNoAssignedJobs.value = show
    }

    const updateLastViewedSchedule = (view: string) => {
      lastViewedSchedule.value = view
    }

    const updateSearch = (value: string) => {
      search.value = value
    }

    const updateFilterReset = (value: boolean) => {
      resetFilters.value = value
    }

    const updateDivisionFiltersExplicitlySet = (value: boolean) => {
      divisionFiltersExplicitlySet.value = value
    }

    const updateResourceTypeFiltersExplicitlySet = (value: boolean) => {
      resourceTypeFiltersExplicitlySet.value = value
    }

    const updateServiceProviderFiltersExplicitlySet = (value: boolean) => {
      serviceProviderFiltersExplicitlySet.value = value
    }

    return {
      search,
      resetFilters,
      updateFilterReset,
      isMigratedFromVuex,
      lastViewedSchedule,
      showOfflineUnits,
      showStandbyUnits,
      showUnitsWithNoAssignedJobs,
      updateShowOfflineUnits,
      updateShowStandbyUnits,
      updateShowUnitsWithNoAssignedJobs,
      updateLastViewedSchedule,
      updateSearch,
      divisionFiltersExplicitlySet,
      resourceTypeFiltersExplicitlySet,
      serviceProviderFiltersExplicitlySet,
      updateServiceProviderFiltersExplicitlySet,
      updateDivisionFiltersExplicitlySet,
      updateResourceTypeFiltersExplicitlySet,
    }
  },
  {
    persist: true,
  },
)
